<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="12" md="6" class="px-md-10" v-if="!app || (app && state === 0)">
        <h1 class="login-title mb-5">Teste de Orientação Profissional</h1>
        <p>
          Olá! Sabemos que a hora de escolher uma profissão pode trazer algumas dúvidas e inseguranças. Por isso, desenvolvemos um Teste de Orientação Profissional para ajudar você a descobrir seus
          interesses, aptidões e possíveis caminhos.
        </p>
        <p>Este material foi desenvolvido pelo time de psicólogas da Unisinos, utilizando como base suas experiências práticas na orientação da carreira de jovens e adultos.</p>

        <div class="text-center" v-if="app">
          <v-btn color="#003da4" @click="state = 1" dark depressed large>Vamos Começar!</v-btn>
        </div>
      </v-col>

      <v-col cols="12" md="6" class="px-0 px-md-5" v-if="!app || (app && state === 1)">
        <v-card class="pa-md-10 px-5 py-10 card-info" flat>
          <v-form v-model="valid" ref="form">
            <div class="text-center text-md-left mx-auto mb-5" style="max-width: 300px;">Mas antes de começarmos, que tal nos <b>passar algumas informações suas?</b></div>
            <h4>Qual seu nome?</h4>
            <v-text-field :rules="required" v-model="object.name" outlined></v-text-field>
            <h4>Qual email mais utiliza?</h4>
            <v-text-field :rules="emailRules" v-model="object.email" outlined></v-text-field>
            <h4>Qual o seu número de celular?</h4>
            <v-text-field :rules="phoneRules" v-model="object.phone" v-mask="'(##) #####-####'" outlined></v-text-field>
          </v-form>
          <div class="text-center">
            <v-btn color="#003da4" @click="send()" dark depressed large>Vamos Começar!</v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
  name: 'Home',
  computed: {
    app() {
      return this.$vuetify.breakpoint.smAndDown
    },
  },
  data: () => ({
    state: 0,
    valid: false,
    object: {},
    required: [(v) => !!v || 'O campo Nome é necessário'],
    emailRules: [(v) => !!v || 'O campo e-mail é necessário', (v) => /.+@.+\..+/.test(v) || 'É preciso um e-mail válido'],
    phoneRules: [(v) => !!v || 'O campo telefone é necessário', (v) => (v && v.length === 15) || 'O telefone precisa ser válido'],
  }),
  directives: {
    mask,
  },
  methods: {
    send() {
      this.$refs.form.validate()
      if (!this.valid) {
        return
      }
      this.$store.dispatch('setUserInfo', this.object)
      this.$router.push('/teste')
    },
  },
  mounted(){
    window.scrollTo(0, 0)
  }
}
</script>
<style>

</style>
